





























import Vue from 'vue';
import Component from 'vue-class-component';
import TInput from '@/lib/form/input/Input.vue';
import TButton from '@/lib/form/button/Button.vue';
import WorkspaceUtils from '../utils/workspace-utils';
import logger from '../logger';

@Component({
  name: 'player-permission-link-settings',
  components: {
    TInput,
    TButton
  },
  props: ['shareableLinkId', 'type', 'shareableGifUrl']
})
export default class PlayerPermissionLinkSettings extends Vue {
  private linkCopyingInProgress = false;
  private gifCopyingInProgress = false;
  private videoId!: string;
  private shareableLinkId!: string;
  private shareableGifUrl!: string;
  private type;

  get collectionShareableLink() {
    return `${this.$user.portalUrlPrefix}/share/${this.shareableLinkId}`;
  }

  get videoShareableLink() {
    return `${this.$user.shareVideoUrlPrefix}/share/${this.shareableLinkId}`;
  }

  copyLinkCode() {
    this.linkCopyingInProgress = true;
    this.$copyTextToClipboard(
      this.type == 'collection'
        ? this.collectionShareableLink
        : this.videoShareableLink
    );
    const input = document.getElementsByName(
      'link_code'
    )[0] as HTMLInputElement;
    input && input.select();
    window.setTimeout(() => {
      this.linkCopyingInProgress = false;
    }, 500);
  }
}
